var _defs, _path, _path2, _polygon, _polygon2, _polygon3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLift142(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 133.13 55.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e20613;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #d4d6d8;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.26,28.33h10.17v-9.17h-10.14V7.43l-9.86,3.4.09,25.49c0,10.82,9.03,19.34,19.86,19.34v-9.16c-5.51-.28-9.91-4.85-9.91-10.44v-.04s-.23-7.69-.23-7.69Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.89,19.6c0-5.59,4.39-10.16,9.92-10.44V0c-10.84,0-19.61,8.78-19.61,19.6l-.35,36.17,9.86-.02v-26.97h10.02v-9.13h-9.84v-.04Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.54 3.76 0 7 0 55.74 9.54 55.74 9.54 3.76"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.48 18.68 15.94 21.92 15.94 55.74 25.48 55.74 25.48 18.68"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "83.48 55.74 93.02 55.74 93.02 6.88 85.53 6.88 70.54 18.27 76.1 25.84 83.46 20.27 83.48 55.74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.82,38.98V7.04h-8.02l-22.56,32.03v9.15l20.66-.11v7.63h10.08v-7.32h6.15v-9.45h-6.31ZM116.76,38.89h-7.7l7.7-11.83v11.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLift142);
export default __webpack_public_path__ + "static/media/lift14_2.a8c7c3fa828dc0bee3723ab867dad401.svg";
export { ForwardRef as ReactComponent };